<template>
    <v-input
        class="w-full min-w-0 flex-1"
        no-margin
        hide-label
        type="text"
        name="search"
        :placeholder="placeholder"
        :auto-focus="autoFocus"
        v-model:value="model"
    />
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        placeholder?: string;
        autoFocus?: boolean;
    }>(),
    {
        placeholder: 'generic.search',
        autoFocus: false,
    },
);

const model = defineModel<string>({ default: '' });
</script>
